module.exports = __webpack_public_path__ + "/bundle/asset/collego-492094982d1bd2e9b2afcc75c9962cbb.png";